import axios from "axios";

const url = process.env.REACT_APP_BASE_API_URL;

export const clienteAlgoritimoDropDown = async () => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(url + "/v1/clientealgoritimo/dropdown", { headers });
};

